import type { CurrencyMeta } from './types';

export function toMinorUnits(displayValue: number, meta: CurrencyMeta): number {
	return Math.round(displayValue * Math.pow(10, meta.digits));
}

export function fromMinorUnits(minorUnits: number, meta: CurrencyMeta): number {
	return Number((minorUnits / Math.pow(10, meta.digits)).toFixed(meta.digits));
}

export function parseToMinorUnits(input: string | number, meta: CurrencyMeta): number {
	if (input === '' || input === undefined || input === null) return 0;
	const value = typeof input === 'number' ? input : parseFloat(input);
	if (isNaN(value)) return 0;
	return toMinorUnits(value, meta);
}

export function limitToDecimalScale(value: string, meta: CurrencyMeta): string {
	if (!value.includes('.')) return value;
	const [intPart = '', decimalPart = ''] = value.split('.');
	if (meta.digits === 0) return intPart;
	return `${intPart}.${decimalPart.slice(0, meta.digits)}`;
}

export function safeParseToMinorUnits(input: unknown, meta: CurrencyMeta): number | undefined {
	if (input === '' || input === undefined || input === null) return undefined;
	const value = typeof input === 'number' ? input : parseFloat(String(input));
	if (isNaN(value)) return undefined;
	return toMinorUnits(value, meta);
}
